/* eslint-disable quote-props */
/* eslint-disable max-len */
import _ from 'lodash';
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { questionSlotData } from '../../../models/FormSpecRegistry';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_022: Question = {
  id: 'pres-022-part-milieux-humides',
  oldId: '36',
  title: 'Part des milieux humides par rapport à la superfie totale du territoire',
  number: '3.6',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      autofill: (values: any, sectionPath: string) => {
        const v1 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-021-superficie-milieux-humides'))) || 0;
        const superficie = parseFloat(_.get(values, 'superficie')) || 1;
        return ((v1 / 100 / superficie) * 100).toFixed(2);
      },
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

export const question_pres_022_v2: Question = question_pres_022;
export const question_pres_022_v3: Question = question_pres_022;
